/**
 * Адреса замеров поиска (`SearchTestingController`, RP-FB28). Литерал `/api/` законен
 * только в файлах `api/urls.ts` (eslint).
 */
const ROOT = '/api/platform/v1/testing/search'

export const PLATFORM_TESTING_URLS = {
  products: `${ROOT}/products`,
  fromCatalog: `${ROOT}/products/from-catalog`,
  product: (id: string) => `${ROOT}/products/${encodeURIComponent(id)}`,
  refresh: (id: string) => `${ROOT}/products/${encodeURIComponent(id)}/refresh`,
  reindex: (id: string) => `${ROOT}/products/${encodeURIComponent(id)}/reindex`,
  photos: (id: string) => `${ROOT}/products/${encodeURIComponent(id)}/photos`,
  photo: (photoId: string) => `${ROOT}/photos/${encodeURIComponent(photoId)}`,
  checkStored: (photoId: string) => `${ROOT}/photos/${encodeURIComponent(photoId)}/check`,
  runs: `${ROOT}/runs`,
  run: (id: string) => `${ROOT}/runs/${encodeURIComponent(id)}`,
  runFrames: (id: string) => `${ROOT}/runs/${encodeURIComponent(id)}/frames`,
  cancelRun: (id: string) => `${ROOT}/runs/${encodeURIComponent(id)}/cancel`,
} as const

/** Байты фото замера: картинка грузится браузером той же сессией (cookie BFF). */
export const testingPhotoUrl = (photoId: string): string => PLATFORM_TESTING_URLS.photo(photoId)

/** Адреса замеров поиска по тексту (`TextSearchTestingController`, RP-FB34). */
const TEXT_ROOT = '/api/platform/v1/testing/text'

export const PLATFORM_TEXT_TESTING_URLS = {
  queries: `${TEXT_ROOT}/queries`,
  query: (id: string) => `${TEXT_ROOT}/queries/${encodeURIComponent(id)}`,
  generate: `${TEXT_ROOT}/queries/generate`,
  checkStored: (id: string) => `${TEXT_ROOT}/queries/${encodeURIComponent(id)}/check`,
  check: `${TEXT_ROOT}/check`,
  runs: `${TEXT_ROOT}/runs`,
  run: (id: string) => `${TEXT_ROOT}/runs/${encodeURIComponent(id)}`,
  cancelRun: (id: string) => `${TEXT_ROOT}/runs/${encodeURIComponent(id)}/cancel`,
} as const

/** Адреса замера «Похожие варианты» (`TwinTestingController`, RP-FB67). */
const TWIN_ROOT = '/api/platform/v1/testing/twin'

export const PLATFORM_TWIN_TESTING_URLS = {
  families: `${TWIN_ROOT}/families`,
  refreshFamilies: `${TWIN_ROOT}/families/refresh`,
  frames: `${TWIN_ROOT}/frames`,
  runs: `${TWIN_ROOT}/runs`,
  run: (id: string) => `${TWIN_ROOT}/runs/${encodeURIComponent(id)}`,
  cancelRun: (id: string) => `${TWIN_ROOT}/runs/${encodeURIComponent(id)}/cancel`,
} as const

/** Выгрузка для калибровки: без `runId` — последний готовый замер «Похожие варианты». */
export const calibrationExportUrl = (format: 'json' | 'csv', runId: string | null): string =>
  `/api/platform/v1/testing/calibration-export?format=${format}${runId === null ? '' : `&runId=${encodeURIComponent(runId)}`}`
